import React from 'react';
import { useTranslation } from 'react-i18next';
import './Team.css';

const Team: React.FC = () => {
  const { t } = useTranslation();

  const teamMembers = [
    {
      name: t('team.members.member1.name'),
      role: t('team.members.member1.role'),
      description: t('team.members.member1.description')
    },
    {
      name: t('team.members.member2.name'),
      role: t('team.members.member2.role'),
      description: t('team.members.member2.description')
    },
    {
      name: t('team.members.member3.name'),
      role: t('team.members.member3.role'),
      description: t('team.members.member3.description')
    },
    {
      name: t('team.members.member4.name'),
      role: t('team.members.member4.role'),
      description: t('team.members.member4.description')
    }
  ];

  return (
    <div className="team-page">
      <div className="team-hero">
        <div className="container">
          <h1 className="page-title">{t('team.title')}</h1>
        </div>
      </div>

      <section className="team-section">
        <div className="container">
          <p className="team-intro">{t('team.intro')}</p>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-card-header">
                  <div className="team-avatar">
                    <span>{member.name.charAt(0)}</span>
                  </div>
                  <div className="team-info">
                    <h3>{member.name}</h3>
                    <p className="team-role">{member.role}</p>
                  </div>
                </div>
                <p className="team-description">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;









